<template>
  <aside class="ownit-banner" aria-label="Pre-IPO and IPO updates">
    <p>
      For IPO and Pre-IPO deals, visit
      <a href="https://ownitmarkets.com" target="_blank" rel="noopener noreferrer">ownitmarkets.com</a>
    </p>
  </aside>
</template>

<script>
export default {
  name: 'OwnitBanner',
};
</script>

<style scoped>
.ownit-banner {
  box-sizing: border-box;
  width: 100%;
  padding: 14px 20px;
  background: #141414;
  color: #f3f3f3;
  text-align: center;
  font-size: 14px;
  line-height: 1.6;
}

.ownit-banner p {
  max-width: 1280px;
  margin: 0 auto;
}

.ownit-banner a {
  color: inherit;
  font-weight: 700;
  white-space: nowrap;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.ownit-banner a:hover {
  text-decoration-thickness: 2px;
}

.ownit-banner a:focus-visible {
  outline: 2px solid currentColor;
  outline-offset: 4px;
  border-radius: 2px;
}

@media (max-width: 767px) {
  .ownit-banner {
    padding: 12px 16px;
    font-size: 12px;
  }
}
</style>
